import {
  EnumOperatorOperationalStatus,
  OperatorByIdDocument,
  useOperatorUpdateMutation,
} from "gql/generated.ts";
import { getMultilingualString } from "shared/utils";

interface UseDangerZoneOptions {
  operatorEntityId: string;
  onSuccess?: (operatorName: string) => void;
  onError?: () => void;
}

export const useDangerZone = ({
  operatorEntityId,
  onSuccess,
  onError,
}: UseDangerZoneOptions) => {
  const [updateOperator, { loading: updateLoading }] =
    useOperatorUpdateMutation({
      refetchQueries: [OperatorByIdDocument],
    });

  const handleUpdateOperationalStatus = async (
    operationalStatus: EnumOperatorOperationalStatus,
  ) => {
    await updateOperator({
      variables: {
        entityId: operatorEntityId,
        record: {
          operationalStatus: operationalStatus,
        },
      },
    })
      .then(async (res) => {
        if (res.data && res.data?.operatorUpdate?.name) {
          const operatorName = getMultilingualString(
            res.data.operatorUpdate.name,
          );
          onSuccess?.(operatorName);
        }
      })
      .catch(() => {
        onError?.();
      });
  };

  return { handleUpdateOperationalStatus, updateLoading };
};
